module.exports = __webpack_public_path__ + "static/media/what-is-lawyerup.81fd2470.gif";